import React from 'react';
import { Search, Filter } from 'lucide-react';

const ReviewsFilters = ({ searchTerm, setSearchTerm, statusFilter, setStatusFilter, isAdminFilter, setIsAdminFilter }) => {
    return (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex flex-col md:flex-row gap-4">
            <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                <input
                    type="text"
                    placeholder="Поиск по тексту отзыва или пользователю..."
                    className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <div className="relative">
                <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} />
                <select
                    className="pl-10 pr-8 py-2 border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 appearance-none w-full md:w-auto"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="all">Все статусы</option>
                    <option value="pending">На модерации</option>
                    <option value="approved">Одобрено</option>
                    <option value="rejected">Отклонено</option>
                </select>
            </div>
            <div className="relative">
                <select
                    className="pl-4 pr-8 py-2 border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 appearance-none w-full md:w-auto"
                    value={isAdminFilter}
                    onChange={(e) => setIsAdminFilter(e.target.value)}
                >
                    <option value="all">Все отзывы</option>
                    <option value="false">От пользователей</option>
                    <option value="true">От администратора</option>
                </select>
            </div>
        </div>
    );
};

export default ReviewsFilters;
